module.exports = __webpack_public_path__ + "img/28.b831c423.jpg";